import layout from "./layout";

export const LAYOUT_NAMESPACE = "layout";

export default layout;
